import { ChangeDetectorRef, Component, ElementRef, ViewChild } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TableDefinition } from "shared/cubiq-services";
import { BfxHedgeOrderStagingRow } from "../../shared/cubiq-services/model/benchmarks/BfxHedgeOrderStagingRow";
import { BfxDialogBaseComponent } from "../bfx-dialogs/bfx-dialog-base.component";
import { BfxDialogData } from "../bfx-dialogs/models/bfx-dialog-data.model";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { ICAutocompleteGenericModel } from "../order-entry/interface/controls/models/bfx-interface-controls.models";
import { OEAlgoParamsComponent } from "../order-entry/interface/oe-panel-algo-params.component";
const logger = LoggerService.for(__dirname);

export class BfxHedgeOrderStrategyParamsConfig {
  public currencyCode: string;
  public orderAmount: string;
  public currencyPair: string;
  public algoType: ICAutocompleteGenericModel;
  public rate: CubiqTS.BigNumber;

  constructor() {}

  public get invertedPair(): string {
    let pair: string = null;
    if (this.currencyPair != null && this.currencyPair.length >= 6) {
      pair = this.currencyPair.substring(3) + this.currencyPair.substring(0, 3);
    }
    return pair;
  }
}

@Component({
  selector: `bfx-hedge-order-strategy-parameters`,
  templateUrl: `./html/bfx-hedge-order-strategy-parameters.html`,
  standalone: false,
})
export class BfxHedgeOrderStrategyParametersComponent extends BfxDialogBaseComponent {
  public description: string = "";
  public messages: Array<string> = [];
  public tableDefinition: TableDefinition = null;
  public showConfirmationMessage: boolean = true;
  public confirmed: boolean = false;
  public subMessage: any = null;
  public isWarning: boolean = false;
  public config: BfxHedgeOrderStrategyParamsConfig = null;
  public algoParams: Array<CubiqTS.StrategyParameterImpl>;

  private stagingRow: BfxHedgeOrderStagingRow = null;

  @ViewChild("panelAlgoParams")
  private algoParamsPanel: OEAlgoParamsComponent;

  public data: any = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      count: 0,
      stlClass: "bfx-dialog-normal",
    },
  };

  constructor(
    protected layoutService: GoldenLayoutService,
    protected translationService: TranslateService,
    protected _element: ElementRef,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      if (this.algoParamsPanel) {
        this.algoParamsPanel.reset();
      }
      this.stagingRow = _dialogData.payload.data;
      this.data.payload = _dialogData.payload;
      this.data.dialogId = _dialogData.dialogId;
      this.algoParams = this.stagingRow.orderRequest.strategyParameters.map(
        (param: CubiqTS.StrategyParameterImpl) =>
          Object.assign(new CubiqTS.StrategyParameterImpl(), param),
      );
      this.config = _dialogData.payload.config;
      this.description = this.createDescription(this.stagingRow);
      NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);
      this.data.dialogData.show = true;
    } catch (ex) {
      logger.out.error("ERROR: BfxDialogOKComponent.openDialog(): Dialog exception! msg:", ex);
    }

    return this.data.dialogEventSubject.asObservable();
  }

  protected createDescription(row: BfxHedgeOrderStagingRow): string {
    let title: string = "";

    if (row.orderRequest.base != null && row.orderRequest.nonBase != null) {
      title = row.orderRequest.base + "/" + row.orderRequest.nonBase + " ";
    } else {
      title = " - ";
    }

    title += row.orderRequest.clientIntent == CubiqTS.OrderIntent.BUY ? "Buy" : "Sell";

    if (row.orderRequest.fixedAmount != null) {
      title += " " + new CubiqTS.BigNumber(row.orderRequest.fixedAmount).toFormat(0);
    } else {
      title += " - ";
    }

    if (row.algoHedgeConfig != null) {
      title += " " + row.algoHedgeConfig.orderType;
    }

    return title;
  }

  public closeDialog() {
    super.closeDialog();

    this.algoParams = null;
    this.stagingRow = null;

    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.dialogData.message_text_ids = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // This is not used but since the dialog is following the standard dialog pattern, it's best to keep them in
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  public actionConfirmed(): void {
    if (this.algoParamsPanel.updateStrategyParameters()) {
      this.stagingRow.orderRequest.strategyParameters = this.algoParams;

      this.confirmed = true;

      if (this.data.payload.callback) {
        this.data.payload.callback(this.data.actionEvent);
      }

      this.closeDialog();
    }
  }
}
